import { gql } from "urql";
export const BulkReorderPriorityViewsMutation = gql `
    mutation BulkReorderPriorityViews($input: [BulkReorderInput!]!) {
        priorityViews {
            bulkReorderPriorityViews(input: $input) {
                priorityViewId
                sortOrder
            }
        }
    }
`;
export const CreatePriorityViewMutation = gql `
    mutation CreatePriorityView($input: PriorityViewCreate!) {
        priorityViews {
            createPriorityView(input: $input) {
                priorityViewId
                name
                sortOrder
            }
        }
    }
`;
export const UpdatePriorityViewMutation = gql `
    mutation UpdatePriorityView($input: PriorityViewUpdate!) {
        priorityViews {
            updatePriorityView(input: $input) {
                priorityViewId
                name
                sortOrder
            }
        }
    }
`;
export const DeletePriorityViewMutation = gql `
    mutation DeletePriorityView($priorityViewId: String!) {
        priorityViews {
            deletePriorityView(priorityViewId: $priorityViewId) {
                priorityViewId
            }
        }
    }
`;
